<template>
  <div class="home">
    <!-- <router-view/> -->
    <menuList></menuList>
    <div class="home-content" :style="{minHeight:minHeight+'px'}">
      <router-view/>
    </div>
  </div>

</template>

<script>
  import menuList from './menu'
  export default {
    name: 'home',
    data () {
      return {
          minHeight:window.innerHeight,
      }
    },
    components:{
      menuList,
    },
    methods:{
      getinfo(){
        var agent = navigator.userAgent.toLowerCase();
        var regStr_ie = /msie [\d.]+;/gi ;
        var regStr_ff = /firefox\/[\d.]+/gi
        var regStr_chrome = /chrome\/[\d.]+/gi ;
        var regStr_saf = /safari\/[\d.]+/gi ;
        //IE
        if(agent.indexOf("msie") > 0)
        {
          return agent.match(regStr_ie) ;
        }
        //firefox
        if(agent.indexOf("firefox") > 0)
        {
          return agent.match(regStr_ff) ;
        }
        //Safari
        if(agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0)
        {
          return agent.match(regStr_saf) ;
        }
        //Chrome
        if(agent.indexOf("chrome") > 0)
        {
          return agent.match(regStr_chrome) ;
        }
      }
    },
    mounted(){
        // console.log(this.getinfo());
        this.ischrome=this.getinfo()[0].indexOf('chrome')==-1 ? false : true;
        // if(this.getinfo()[0].indexOf('chrome')==-1){
        //   this.$notify({
        //     title: '提示',
        //     message: '推荐使用谷歌浏览器Chrome访问，点这里下载"https://www.google.cn/intl/zh-CN/chrome/"',
        //     duration: 0,
        //     showClose:false,
        //   });
        //   // this.$message('推荐使用谷歌浏览器Chrome访问，点这里下载"https://www.google.cn/intl/zh-CN/chrome/"');
        // }
      if(!this.ischrome){
        this.$message({
          dangerouslyUseHTMLString: true,
          showClose: true,
          duration:10000,
          type: 'warning',
          message: `<a href="https://www.google.cn/intl/zh-CN/chrome/" target="_blank" class="black-font font-size14">推荐使用谷歌浏览器Chrome访问，点<span class="green-font">这里下载</span></a>`
        });
      }
    },

  }
</script>

<style>
  .home{
    width:100%;
  }
  .home-content{
      padding: 82px 15px 0 215px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      background: #eef2f2;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue